import { PlayerMix, PlayerProgram } from '@splixer/player';
import { uBoolean } from '@hidat/huijs-common';
import { FlatBrandedContent, ContentMenuItem } from '../../models';

export interface Pv2MenuConverterConfig {
  displayPlayButtons?: uBoolean;
  displayTagLines?: uBoolean;
  displayHostName?: uBoolean;
  baseRoute?: string[] | undefined;
  includeBackgroundImage?: uBoolean;
}

/**
 * Converts an array of Mixes to Content Menu Items, so they can be used for playable menu lists
 * @param items
 * @param config
 */
export function mixesToMenuItems(
  items: PlayerMix[],
  config: Pv2MenuConverterConfig = {},
): ContentMenuItem[] {
  const menuItems: ContentMenuItem[] = [];
  if (items) {
    for (const item of items) {
      if (item.uid) {
        const mi: ContentMenuItem = {
          id: item.uid,
          name: item.name ?? 'No Name!',
          duration: item.duration,
        };
        if (config.displayPlayButtons) {
          mi.contentId = item.uid;
        }
        if (config.displayTagLines) {
          mi.tagLine = item.tagLine;
        }
        if (config.baseRoute) {
          mi.routerLink = [...config.baseRoute, item.uid];
        }
        menuItems.push(mi);
      }
    }
  }
  return menuItems;
}

/**
 * Converts an array of Mixes to Content Menu Items, so they can be used for playable menu lists
 * @param items
 * @param config
 */
export function programToMenuItems(
  items: PlayerProgram[],
  config: Pv2MenuConverterConfig = {},
): ContentMenuItem[] {
  const menuItems: ContentMenuItem[] = [];
  if (items) {
    for (const item of items) {
      if (item.uid) {
        const mi: ContentMenuItem = {
          id: item.uid,
          name: item.name ?? 'No Name!',
        };
        if (config.displayPlayButtons) {
          if (item._lastShowMix) {
            mi.contentId = item._lastShowMix.uid;
            mi.title = item._lastShowMix.tagLine;
          }
        }
        if (config.displayTagLines) {
          mi.tagLine = item.tagLine;
        }
        if (config.displayHostName && item._host?.name) {
          mi.thirdLine = 'Hosted by ' + item._host.name;
        }
        if (config.baseRoute) {
          mi.routerLink = [...config.baseRoute, item.uid!];
        }
        if (config.includeBackgroundImage) {
          mi.backgroundImage = item.branding.avatarImageUrl;
        }
        menuItems.push(mi);
      }
    }
  }
  return menuItems;
}

/**
 * Converts an array of Mixes to Content Menu Items, so they can be used for playable menu lists
 * @param items
 * @param config
 */
export function flatBrandedContentToMenuItems(
  items: FlatBrandedContent[],
  config: Pv2MenuConverterConfig = {},
): ContentMenuItem[] {
  const menuItems: ContentMenuItem[] = [];
  if (items) {
    for (const item of items) {
      if (item.id) {
        const mi: ContentMenuItem = {
          id: item.id,
          name: item.name ?? 'No Name!',
        };
        if (config.displayPlayButtons) {
          mi.contentId = item.contentId;
          mi.title = item.tagLine;
        }
        if (config.displayTagLines) {
          mi.tagLine = item.tagLine;
        }
        if (config.displayHostName && item.hostName) {
          mi.thirdLine = 'Hosted by ' + item.hostName;
        }
        if (config.baseRoute) {
          mi.routerLink = [...config.baseRoute, item.id.toString()];
        }
        if (config.includeBackgroundImage) {
          mi.backgroundImage = item.avatarImageUrl;
        }
        menuItems.push(mi);
      }
    }
  }
  return menuItems;
}
